import { FormEvent, useState } from "react";
import styles from "./Signup.module.css";
import logo from "../../assets/images/enif_logo_full.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link, useNavigate } from "react-router-dom";
import { faEyeSlash, faEye } from "@fortawesome/free-regular-svg-icons";
import instance from "../../api";
import { AxiosError } from "axios";
import { setCookie, showToast } from "../../utilities/helpers";
interface InputType {
  firstName: { value: string; isValid: null | boolean; isTouched: boolean };
  lastName: { value: string; isValid: null | boolean; isTouched: boolean };
  email: { value: string; isValid: null | boolean; isTouched: boolean };
  password: { value: string; isValid: null | boolean; isTouched: boolean };
  confirmPass: { value: string; isValid: null | boolean; isTouched: boolean };
  error: "";
  success: boolean;
}
export default function Signup() {
  const navigate = useNavigate();
  const [formInput, setFormInputs] = useState<InputType>({
    firstName: { value: "", isValid: null, isTouched: false },
    lastName: { value: "", isValid: null, isTouched: false },
    email: { value: "", isValid: null, isTouched: false },
    password: { value: "", isValid: null, isTouched: false },
    confirmPass: { value: "", isValid: null, isTouched: false },
    error: "",
    success: false,
  });

  const [password, setPassword] = useState({
    showPassword: false,
    showConfirmPassword: false,
  });

  const disableSubmitButton = Object.values(formInput).some(
    (value) => value.isValid === false || (value.isTouched && !value.isValid)
  );

  const handleShowPassword = () => {
    setPassword((prevValue) => ({
      ...prevValue,
      showPassword: !prevValue.showPassword,
    }));
  };

  const handleShowConfirmPassword = () => {
    setPassword((prevValue) => ({
      ...prevValue,
      showConfirmPassword: !prevValue.showConfirmPassword,
    }));
  };

  const handleSignup = async (e: FormEvent<HTMLFormElement>) => {
    localStorage.removeItem("selectedPlatforms")
    localStorage.removeItem("businessName")
    localStorage.removeItem("email")
    localStorage.removeItem("industry")
    localStorage.removeItem("phoneNumber")
    localStorage.removeItem("businessDescription")
    localStorage.removeItem("bankName")
    localStorage.removeItem("accountName")
    localStorage.removeItem("accountNumber")
    localStorage.removeItem("ownersFullName")
    localStorage.removeItem("businessPhoneNumber")
    localStorage.removeItem("businessAddress")
    localStorage.removeItem("plan")
    localStorage.removeItem("onboard1")
    localStorage.removeItem("onboard2")
    localStorage.removeItem("onboard3")
    e.preventDefault();
    const data = {
      firstName: formInput.firstName.value,
      lastName: formInput.lastName.value,
      email: formInput.email.value,
      password: formInput.password.value,
      confirm_password: formInput.confirmPass.value,
      phoneNo: "09066036330",
    };
    try {
      const response = await instance.post("api/user/signup", { ...data });
      console.log(response.status, response.data);
      showToast("primary", "Success!", "Signed up successfully")
      handleSignin(e)
      setFormInputs((prev) => ({
        ...prev,
        firstName: { value: "", isValid: null, isTouched: false },
        lastName: { value: "", isValid: null, isTouched: false },
        email: { value: "", isValid: null, isTouched: false },
        password: { value: "", isValid: null, isTouched: false },
        confirmPass: { value: "", isValid: null, isTouched: false },
      }));
      // navigate("/login");
    } catch (error) {
      if (error instanceof AxiosError) {
        if (error.response?.status === 400) {
          const message = error.response.data?.message;
          showToast("secondary", "Error!", message)
          setFormInputs((prev) => ({
            ...prev,
            error: message,
          }));
        }
      }
      console.log(error);
    }
  };

  const handleSignin = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    // setIsLoading(true);
    const data = {
      email: formInput.email.value,
      password: formInput.password.value,
    };
    try {
      const response = await instance.post("api/user/login", { ...data });
      const business: { businessId: string }= response.data?.business;
      console.log(response.data, business);
      const userData: {
        id: string;
        userId: string;
        email: string;
        firstName: string;
        lastName: string;
        token: string;
        businessId: string;
        phoneNo: string;
        password: string;
      } =
        business && business.businessId
          ? {
              id: response.data.user._id,
              userId: response.data.user.userId,
              email: response.data.user.email,
              firstName: response.data.user.firstName,
              lastName: response.data.user.lastName,
              phoneNo: response.data.user.phoneNo,
              password: response.data.user.password,
              token: "",
              businessId: business?.businessId,
            }
          : {
              id: response.data.user._id,
              userId: response.data.user.userId,
              email: response.data.user.email,
              firstName: response.data.user.firstName,
              lastName: response.data.user.lastName,
              phoneNo: response.data.user.phoneNo,
              password: response.data.user.password,
              token: "",
              businessId: "",
            };
      // const userData: {
      //   id: string;
      //   userId: string;
      //   email: string;
      //   firstName: string;
      //   lastName: string;
      //   token: string;
      //   businessId: string;
      // } = {
      //   id: response.data._id,
      //   userId: response.data.userId,
      //   email: response.data.email,
      //   firstName: response.data.firstName,
      //   lastName: response.data.lastName,
      //   token: "",
      //   businessId:
      //     Array.isArray(business) && business.length > 0
      //       ? business[0]?.businessId
      //       : "",
      // };
      console.log(business, userData);

      setCookie("Authorization", response.headers['authorization'], 2)
      // const prevuserData = JSON.parse(localStorage.getItem("user") as string);

      // if(userData.id !== prevuserData.id){
      //   localStorage.removeItem("selectedPlatforms")
      //   localStorage.removeItem("businessName")
      //   localStorage.removeItem("email")
      //   localStorage.removeItem("industry")
      //   localStorage.removeItem("phoneNumber")
      //   localStorage.removeItem("businessDescription")
      //   localStorage.removeItem("bankName")
      //   localStorage.removeItem("accountName")
      //   localStorage.removeItem("accountNumber")
      //   localStorage.removeItem("ownersFullName")
      //   localStorage.removeItem("businessPhoneNumber")
      //   localStorage.removeItem("businessAddress")
      //   localStorage.removeItem("plan")
      //   localStorage.removeItem("onboard1")
      //   localStorage.removeItem("onboard2")
      //   localStorage.removeItem("onboard3")
      // }

      localStorage.setItem("user", JSON.stringify(userData));
      localStorage.setItem("business", JSON.stringify(business))
      localStorage.removeItem('mainpage')

      setFormInputs((prev) => ({
        ...prev,
        email: { value: "", isValid: null, isTouched: false },
        password: { value: "", isValid: null, isTouched: false },
      }));
      // setIsLoading(false);

      showToast("primary", "Success!", "Signed in successfully")
      if(business && business.businessId){
        localStorage.setItem("mainpage", "item1")
      }else{
        localStorage.setItem("mainpage", "onboarding")
      }
      navigate("/");
    } catch (error) {
      if (error instanceof AxiosError) {
        // if (error.response?.status === 400) {
        //   const message = error.response.data?.message;
        //   setFormInputs((prev) => ({
        //     ...prev,
        //     error: message,
        //   }));
        // }
        if (error.response?.status) {
          const message = error.response.data?.message;

          showToast("secondary", "Error!", message)
          setFormInputs((prev) => ({
            ...prev,
            error: message,
          }));
        }else{
          showToast("secondary", "Error!", error.message)
        }
      }
      // setIsLoading(false);
      console.log(error);
    }
  };

  const validateName = (value: string) => value.length > 0;

  const validateEmail = (value: string) =>
    value.length > 0 && value.includes("@") && value.includes(".");

  const validatePassword = (value: string) => value.length > 4;

  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <img src={logo} alt="enif" />
      </div>
      <div className={styles.body}>
        <p>Create An Enif Account</p>
        <p>Set up an Enif account by providing the necessary information</p>
        {formInput.error && (
          <div className={styles["error-message"]}>{formInput.error}</div>
        )}
        <div className={styles.formWrapper}>
          <form className={styles["signup-form"]} onSubmit={handleSignup}>
            <div className={styles["twin-input"]}>
              <input
                type="text"
                placeholder="First Name"
                className={`${
                  !formInput.firstName.isValid &&
                  formInput.firstName.isTouched &&
                  styles["error"]
                }`}
                onFocus={() =>
                  setFormInputs((prevState) => {
                    return {
                      ...prevState,
                      firstName: { ...prevState.firstName, isTouched: true },
                    };
                  })
                }
                onChange={(e) =>
                  setFormInputs((prevState) => ({
                    ...prevState,
                    firstName: {
                      value: e.target.value,
                      isValid: validateName(e.target.value),
                      isTouched: true,
                    },
                  }))
                }
              />
              <input
                type="text"
                placeholder="Last Name"
                className={`${
                  !formInput.lastName.isValid &&
                  formInput.lastName.isTouched &&
                  styles["error"]
                }`}
                onFocus={() =>
                  setFormInputs((prevState) => {
                    return {
                      ...prevState,
                      lastName: { ...prevState.lastName, isTouched: true },
                    };
                  })
                }
                onChange={(e) =>
                  setFormInputs((prevState) => ({
                    ...prevState,
                    lastName: {
                      value: e.target.value,
                      isValid: validateName(e.target.value),
                      isTouched: true,
                    },
                  }))
                }
              />
            </div>
            <div>
              <input
                type="email"
                placeholder="Email Address"
                className={`${
                  !formInput.email.isValid &&
                  formInput.email.isTouched &&
                  styles["error"]
                }`}
                onFocus={() =>
                  setFormInputs((prevState) => {
                    return {
                      ...prevState,
                      email: { ...prevState.email, isTouched: true },
                    };
                  })
                }
                onChange={(e) =>
                  setFormInputs((prevState) => ({
                    ...prevState,
                    email: {
                      value: e.target.value,
                      isValid: validateEmail(e.target.value),
                      isTouched: true,
                    },
                  }))
                }
              />
            </div>
            <div>
              <div
                className={`${styles.password} ${
                  !formInput.password.isValid &&
                  formInput.password.isTouched &&
                  styles["error"]
                }`}
              >
                <input
                  type={password.showPassword ? "text" : "password"}
                  placeholder="Enter password"
                  onFocus={() =>
                    setFormInputs((prevState) => {
                      return {
                        ...prevState,
                        password: { ...prevState.password, isTouched: true },
                      };
                    })
                  }
                  onChange={(e) =>
                    setFormInputs((prevState) => ({
                      ...prevState,
                      password: {
                        ...prevState.password,
                        value: e.target.value,
                        isValid: validatePassword(e.target.value),
                      },
                    }))
                  }
                />
                <span onClick={handleShowPassword}>
                  {!password.showPassword ? (
                    <FontAwesomeIcon icon={faEye} />
                  ) : (
                    <FontAwesomeIcon icon={faEyeSlash} />
                  )}
                </span>
              </div>
            </div>
            <div>
              <div
                className={`${styles.password} ${
                  !formInput.confirmPass.isValid &&
                  formInput.confirmPass.isTouched &&
                  styles["error"]
                }`}
              >
                <input
                  type={password.showConfirmPassword ? "text" : "password"}
                  placeholder="Confirm password"
                  onFocus={() =>
                    setFormInputs((prevState) => {
                      return {
                        ...prevState,
                        confirmPass: {
                          ...prevState.confirmPass,
                          isTouched: true,
                        },
                      };
                    })
                  }
                  onChange={(e) =>
                    setFormInputs((prevState) => ({
                      ...prevState,
                      confirmPass: {
                        ...prevState.confirmPass,
                        value: e.target.value,
                        isValid: validatePassword(e.target.value),
                      },
                    }))
                  }
                />
                <span onClick={handleShowConfirmPassword}>
                  {!password.showConfirmPassword ? (
                    <FontAwesomeIcon icon={faEye} />
                  ) : (
                    <FontAwesomeIcon icon={faEyeSlash} />
                  )}
                </span>
              </div>     
            </div>
            <div>
            </div>
            <div>
              <input
                type="submit"
                value="Sign up"
                disabled={disableSubmitButton}
              />
            </div>
            <p>
              Already have an account? <Link to="/login">Log in</Link>
            </p>
          </form>
        </div>
      </div>
    </div>
  );
}
